import React from 'react';
import AnimateHeight from 'react-animate-height';
import { NewIconNames } from '../../../../components/common/icon/new-icon-names';
import i18n from '../../../../utils/i18n/i18n';
import { HeaderButton } from '../header-button/header-button';
import styles from './collapsible.scss';

interface Props {
  title: React.ReactNode;
  isCollapsed?: boolean;
  onCloseClick(): void;
  onToggleCollapseClick(): void;
  children: React.ReactNode;
}

export class Collapsible extends React.Component<Props> {
  public render() {
    const {
      title,
      isCollapsed,
      onCloseClick,
      onToggleCollapseClick,
      children,
    } = this.props;
    const toggleButtonHint = isCollapsed
      ? 'operation-panel.maximize'
      : 'operation-panel.minimize';

    return (
      <div className={styles.collapsible}>
        <div className={styles.header}>
          <span className={styles.title} data-hook="title">
            {title}
          </span>

          <div className={styles.collapseButton}>
            <HeaderButton
              hint={i18n.t(toggleButtonHint)}
              icon={
                isCollapsed ? NewIconNames.ChevronUp : NewIconNames.ChevronDown
              }
              onClick={onToggleCollapseClick}
            />
          </div>

          <div>
            <HeaderButton
              hint={i18n.t('operation-panel.close')}
              icon={NewIconNames.X}
              onClick={onCloseClick}
            />
          </div>
        </div>

        <AnimateHeight duration={400} height={isCollapsed ? 0 : 'auto'}>
          <div className={styles.body}>{children}</div>
        </AnimateHeight>
      </div>
    );
  }
}
